import DefaultStakeTypeFooterBar from './components/DefaultStakeTypeFooterBar';
import EntryFooterBar from './components/EntryFooterBar';
import ExpressStakeTypeFooterBar from './components/ExpressFooterBar';

function getPresetsAndFreebetsBar(type: 'entry'): typeof EntryFooterBar;
function getPresetsAndFreebetsBar(type: 'single'): typeof DefaultStakeTypeFooterBar;
function getPresetsAndFreebetsBar(type: 'express'): typeof ExpressStakeTypeFooterBar;
function getPresetsAndFreebetsBar(type: 'system'): typeof DefaultStakeTypeFooterBar;
function getPresetsAndFreebetsBar(type: 'entry' | 'single' | 'express' | 'system') {
  switch (type) {
    case 'entry':
      return EntryFooterBar;
    case 'single':
      return DefaultStakeTypeFooterBar;
    case 'express':
      return ExpressStakeTypeFooterBar;
    case 'system':
      return DefaultStakeTypeFooterBar;
  }
}

export { getPresetsAndFreebetsBar };
